'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var omitProps = exports.omitProps = function omitProps(Component, omitted) {
  return function (props) {
    var filteredProps = _extends({}, props);
    omitted.forEach(function (propName) {
      delete filteredProps[propName];
    });
    return _react2.default.createElement(Component, filteredProps);
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/Props.js
// module id = 666
// module chunks = 3 4